import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	heading: {
		id: 'software-deployment-frequency-report.welcome-message.heading',
		defaultMessage: 'View and improve your deployment frequency',
		description: 'Title of the Deployment Frequency welcome message',
	},
	firstParagraph: {
		id: 'software-deployment-frequency-report.welcome-message.first-paragraph',
		defaultMessage:
			'The Deployment frequency report leverages your deployments data to get you visibility into:',
		description: 'First paragraph Deployment Frequency welcome message',
	},
	point1: {
		id: 'software-deployment-frequency-report.welcome-message.point-1',
		defaultMessage: 'How often your team is deploying to production',
		description: 'First point of the Deployment Frequency report welcome message',
	},
	point2: {
		id: 'software-deployment-frequency-report.welcome-message.point-2',
		defaultMessage: 'Whether your deployment frequency is effective in managing risk',
		description: 'Second point of the Deployment Frequency report welcome message',
	},
	lastParagraph: {
		id: 'software-deployment-frequency-report.welcome-message.last-paragraph',
		defaultMessage: 'Take it for a spin and let us know what you think.',
		description: 'Last paragraph of the Deployment Frequency report welcome message',
	},
	gotIt: {
		id: 'software-deployment-frequency-report.welcome-message.got-it',
		defaultMessage: 'Got it',
		description: 'Text on a button signaling the user understands what they read',
	},
});
